import {
  GeneralIcon
} from "./chunk-JQYOYMSZ.mjs";

// src/icon/src/general/success.tsx
import { jsx } from "react/jsx-runtime";
var Path = () => /* @__PURE__ */ jsx(
  "path",
  {
    d: "M12 21.75a9.75 9.75 0 100-19.5 9.75 9.75 0 000 19.5zm-4.93-9.4a.75.75 0 000 1.06l2.34 2.35a.74.74 0 001.05 0l6.48-6.47a.74.74 0 00-1.05-1.05l-5.95 5.94-1.82-1.82a.75.75 0 00-1.05 0zm0 0",
    fill: "currentColor",
    fillRule: "evenodd"
  }
);
var SuccessIcon = (props) => /* @__PURE__ */ jsx(GeneralIcon, { ...props, children: /* @__PURE__ */ jsx(Path, {}) });

export {
  SuccessIcon
};
